/**
 * creates a date from a dateUrl in YYYY-MM-DD format
 */
export default (dateUrl: string) => {
    const [year, month, date] = dateUrl.split('-').map((x) => parseInt(x, 10));
    return new Date(year, month - 1, date);
};
